import { ToolGroup } from '@techwan/map-tools';

export class DeploymentGroup extends ToolGroup {
  public constructor() {
    super('deployment');
    this.oneAtATime = true;
  }
}
